import axios from 'axios'
import configData from '@/mixins/config'
import store from '@/store/model-store'

const isDebug = process.env.NODE_ENV !== 'production'

const onSuccess = (resp) => {
  if (isDebug) console.log(' << ' + JSON.stringify(resp.data))
  return Promise.resolve(resp.data)
}

function showError (bvModal, errorMsg) {
  // 1) 旧BootstrapVue互換 / あなたの CommonModal 実装（msgBoxOk を持つ）を優先
  if (bvModal && typeof bvModal.msgBoxOk === 'function') {
    // options は CommonModal 側が無視してもOK（互換のため渡す）
    return bvModal.msgBoxOk(errorMsg, {
      title: '',
      size: 'sm',
      buttonSize: 'sm',
      okVariant: 'primary',
      okTitle: '確認',
      headerClass: 'p-2 border-bottom-0',
      footerClass: 'p-2 border-top-0',
      centered: true,
      dialogClass: 'align-items-start t-10r'
    })
  }

  // 2) フォールバック（最低限）
  // eslint-disable-next-line no-alert
  alert(errorMsg)
}

const onError = (err, bvModal) => {
  let errorMsg = 'エラーが発生しました'
  if (err?.response?.data?.message) errorMsg = err.response.data.message
  else if (err?.message) errorMsg = err.message

  showError(bvModal, errorMsg)
  return Promise.reject(err)
}

function createAxiosInstance () {
  axios.defaults.withCredentials = true
  return axios.create({
    withCredentials: true,
    baseURL: configData.config.apiURL
  })
}

function toQueryParams (params) {
  // 現行踏襲：paramsをJSON.stringifyして渡す仕様
  return { params: JSON.stringify(params) }
}

export default {
  get: (path, bvModal, params, callbackSuccess, callbackError, callbackFinally) => {
    const resSuccess = callbackSuccess || onSuccess
    const resError = callbackError || onError

    if (isDebug) {
      let logMsg = 'GET ' + configData.config.apiURL + path
      if (params) logMsg += ' params:: ' + JSON.stringify(params)
      console.log(logMsg)
    }

    const axiosInstance = createAxiosInstance()

    return axiosInstance
      .get(path, toQueryParams(params))
      .then(resSuccess)
      .catch((err) => {
        console.log(err)
        return resError(err, bvModal)
      })
      .finally(callbackFinally)
  },

  post: (path, bvModal, params, callbackSuccess, callbackError, callbackFinally) => {
    const resSuccess = callbackSuccess || onSuccess
    const resError = callbackError || onError

    if (isDebug) {
      let logMsg = 'POST ' + configData.config.apiURL + path
      if (params) logMsg += ' params:: ' + JSON.stringify(params)
      console.log(logMsg)
    }

    const axiosInstance = createAxiosInstance()

    return axiosInstance
      .post(path, params)
      .then(resSuccess)
      .catch((err) => {
        console.log(err)
        return resError(err, bvModal)
      })
      .finally(callbackFinally)
  },

  put: (path, bvModal, params, callbackSuccess, callbackError, callbackFinally) => {
    const resSuccess = callbackSuccess || onSuccess
    const resError = callbackError || onError

    if (isDebug) {
      let logMsg = 'PUT ' + configData.config.apiURL + path
      if (params) logMsg += ' params:: ' + JSON.stringify(params)
      console.log(logMsg)
    }

    const axiosInstance = createAxiosInstance()

    return axiosInstance
      .put(path, params)
      .then(resSuccess)
      .catch((err) => {
        console.log(err)
        return resError(err, bvModal)
      })
      .finally(callbackFinally)
  },

  delete: (path, bvModal, params, callbackSuccess, callbackError, callbackFinally) => {
    const resSuccess = callbackSuccess || onSuccess
    const resError = callbackError || onError

    if (isDebug) {
      let logMsg = 'DELETE ' + configData.config.apiURL + path
      if (params) logMsg += ' params:: ' + JSON.stringify(params)
      console.log(logMsg)
    }

    const axiosInstance = createAxiosInstance()

    return axiosInstance
      .delete(path, toQueryParams(params))
      .then(resSuccess)
      .catch((err) => {
        console.log(err)
        return resError(err, bvModal)
      })
      .finally(callbackFinally)
  },

  getStore: (name, mainContentName, key) => {
    if (store.getters.model === null || !(name in store.getters.model)) return null

    if (mainContentName) {
      if (!(mainContentName in store.getters.model[name])) return null
      if (!key) return store.getters.model[name][mainContentName]
      if (key in store.getters.model[name][mainContentName]) {
        return store.getters.model[name][mainContentName][key]
      }
    } else {
      if (!key) return store.getters.model[name]
      if (key in store.getters.model[name]) return store.getters.model[name][key]
    }
    return null
  },

  validateStatus: (res) => {
    if (res.status !== 'success') {
      let errorMessage = configData.consts.errorMsg.api
      if (res.message) errorMessage = res.message
      throw new Error(errorMessage)
    }
  }
}
